import { render, staticRenderFns } from "./skeleton01.vue?vue&type=template&id=01e6d2f5&scoped=true"
import script from "./skeleton01.vue?vue&type=script&lang=js"
export * from "./skeleton01.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e6d2f5",
  null
  
)

export default component.exports